import i18n from "i18next";

export const formatNumber = (value: number): string => {
  return value.toLocaleString(i18n.language);
};
